import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

/* ------------------------------ helpers ------------------------------ */
const key = (x) => String(x ?? "");
const pickData = (res) => res?.data ?? res;

/* --------------------------------------------------------------------- */

export const adminTenantApi = createApi({
  reducerPath: "adminTenantApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    credentials: "include",
  }),
  tagTypes: ["TENANT"],
  endpoints: (builder) => ({

    /* --------------------------- TENANT LIST --------------------------- */
    // useGetTenantsQuery({ page, limit, search })
    getTenants: builder.query({
      query: (args = {}) => {
        const {
          page = 1,
          limit = 20,
          search = "",
        } = args || {};

        const params = { page, limit };
        if (search) params.search = search;

        return { url: "/admin/tenants", method: "GET", params };
      },

      providesTags: (result) => {
        const rows = pickData(result);
        if (Array.isArray(rows)) {
          return [
            ...rows.map((t) => ({
              type: "TENANT",
              id: key(t.tenantId),
            })),
            { type: "TENANT", id: "LIST" },
          ];
        }
        return [{ type: "TENANT", id: "LIST" }];
      },

      serializeQueryArgs: ({ endpointName, queryArgs }) => {
        const a = queryArgs || {};
        return [
          endpointName,
          a.page || 1,
          a.limit || 20,
          a.search || "",
        ].join("|");
      },

      keepUnusedDataFor: 60,
      refetchOnMountOrArgChange: false,
      refetchOnFocus: false,
      refetchOnReconnect: false,
    }),

    /* ------------------------ TOGGLE TENANT ------------------------ */
    // useToggleTenantMutation()
    toggleTenant: builder.mutation({
      query: ({ tenantId, isActive }) => ({
        url: "/admin/toggle-tenant",
        method: "POST",
        body: { tenantId, isActive },
      }),
      invalidatesTags: (_res, _err, arg) => [
        { type: "TENANT", id: key(arg?.tenantId) },
        { type: "TENANT", id: "LIST" },
      ],
    }),

    

 

   updateTenantPlan: builder.mutation({
  query: ({ tenantId, plan, price }) => ({
    url: "/admin/update-tenant-plan",
    method: "POST",
    body: { tenantId, plan, price },
  }),
  invalidatesTags: (_res, _err, arg) => [
    { type: "TENANT", id: key(arg?.tenantId) },
    { type: "TENANT", id: "LIST" },
  ],
}),



getEnquiries: builder.query({
      query: (args = {}) => {
        const { page = 1, limit = 20, search = "" } = args || {};
        const params = { page, limit };
        if (search) params.search = search;

        return { url: "/admin/enquiries", method: "GET", params };
      },

      providesTags: (result) => {
        const rows = pickData(result)?.data || [];
        if (Array.isArray(rows)) {
          return [
            ...rows.map((e) => ({
              type: "ENQUIRY",
              id: key(e._id),
            })),
            { type: "ENQUIRY", id: "LIST" },
          ];
        }
        return [{ type: "ENQUIRY", id: "LIST" }];
      },
    }),

    // useUpdateEnquiryStatusMutation()
    updateEnquiryStatus: builder.mutation({
      query: ({ enquiryId, status }) => ({
        url: "/admin/update-enquiry-status",
        method: "POST",
        body: { enquiryId, status },
      }),
      invalidatesTags: (_res, _err, arg) => [
        { type: "ENQUIRY", id: key(arg?.enquiryId) },
        { type: "ENQUIRY", id: "LIST" },
      ],
    }),

    updateTenantSms: builder.mutation({
  query: ({  tenantId,balance, totalUsed }) => ({
    url: "/admin/update-sms",
    method: "POST",
    body: { tenantId, balance, totalUsed },
  }),
  invalidatesTags: (_res, _err, arg) => [
    { type: "TENANT", id: key(arg?.tenantId) },
    { type: "TENANT", id: "LIST" },
  ],
}),
 

  }),
});

/* ----------------------------- hooks ----------------------------- */
export const {
  useGetTenantsQuery,
  useToggleTenantMutation,
  useUpdateTenantPlanMutation,

    useGetEnquiriesQuery,
  useUpdateEnquiryStatusMutation,
  useUpdateTenantSmsMutation
} = adminTenantApi;

export default adminTenantApi;